import React, { useEffect, useState } from 'react';
import b2bService from '../../services/b2bService';

/** Records a payment against one invoice, always taken from one of the client's advances. */
const B2bPaymentModal = ({ invoice, onClose, onDone }) => {
  const [advances, setAdvances] = useState(null);
  const [advanceId, setAdvanceId] = useState('');
  const [amount, setAmount] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    b2bService.getAdvances(invoice.partyID)
      .then((list) => {
        if (cancelled) return;
        const usable = list.filter((a) => Number(a.unallocatedAmount) > 0);
        setAdvances(usable);
        if (usable.length > 0) { setAdvanceId(String(usable[0].advanceID)); setAmount(String(Math.min(Number(invoice.balanceAmount), Number(usable[0].unallocatedAmount)))); }
      })
      .catch((err) => { if (!cancelled) { setAdvances([]); setError(err.response?.data?.message || 'Could not load the advances.'); } });
    return () => { cancelled = true; };
  }, [invoice.partyID]); // eslint-disable-line react-hooks/exhaustive-deps

  const chosen = (advances || []).find((a) => String(a.advanceID) === advanceId);
  const balance = Number(invoice.balanceAmount);
  const most = chosen ? Math.min(balance, Number(chosen.unallocatedAmount)) : 0;

  const choose = (id) => {
    setAdvanceId(id);
    const a = (advances || []).find((x) => String(x.advanceID) === id);
    if (a) setAmount(String(Math.min(balance, Number(a.unallocatedAmount))));
  };

  const submit = async (e) => {
    e.preventDefault();
    const value = Number(amount);
    if (!chosen) { setError('Choose the advance the money comes from.'); return; }
    if (!(value > 0) || value > most) { setError(`Enter an amount above 0 and up to ₹${most.toFixed(2)}.`); return; }
    setSaving(true);
    setError('');
    try {
      await b2bService.allocatePayment({ invoiceId: invoice.invoiceID, advanceId: chosen.advanceID, amount: value });
      onDone();
    } catch (err) {
      setError(err.response?.data?.message || 'The payment could not be recorded.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-label="Record payment" onClick={onClose}>
      <form className="modal-dialog" style={{ maxWidth: 460 }} onClick={(e) => e.stopPropagation()} onSubmit={submit}>
        <div className="modal-header"><h3 style={{ margin: 0 }}>Record payment · {invoice.invoiceNumber}</h3></div>
        <div className="modal-body" style={{ display: 'grid', gap: 12 }}>
          <div>Balance on this invoice: <strong>₹{balance.toFixed(2)}</strong></div>
          {advances === null ? <div>Loading advances…</div> : advances.length === 0 ? (
            <div role="alert" style={{ color: '#b91c1c' }}>This client has no advance with a balance. Add the advance first (Party Master), then record the payment.</div>
          ) : (
            <>
              <label className="form-label" htmlFor="pay-adv">Take the money from</label>
              <select id="pay-adv" className="form-select" value={advanceId} onChange={(e) => choose(e.target.value)}>
                {advances.map((a) => (
                  <option key={a.advanceID} value={a.advanceID}>{a.receiptNumber} · {a.paymentMode} · ₹{Number(a.unallocatedAmount).toFixed(2)} left</option>
                ))}
              </select>
              <label className="form-label" htmlFor="pay-amt">Amount (up to ₹{most.toFixed(2)})</label>
              <input id="pay-amt" className="form-input" type="number" min="0.01" max={most} step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} />
            </>
          )}
          {error && <div role="alert" style={{ color: '#b91c1c', fontWeight: 600 }}>{error}</div>}
        </div>
        <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={saving || !chosen}>{saving ? 'Saving…' : 'Record payment'}</button>
        </div>
      </form>
    </div>
  );
};

export default B2bPaymentModal;
